module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_03.jpg?v=5bc49eba";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_03.jpg
 ** module id = 60
 ** module chunks = 1 2
 **/